<script setup lang="ts">
import { computed } from 'vue';

import MediaCard from '@/components/dashingUI/MediaCard.vue';
import { VISION_AI_SUMMARY_INTERACTIONS } from '@/components/VisionAi/constants';
import type { LibraryMediaWidgetData } from '@/components/VisionAi/widgets/visionWidget.types';
import { useVisionAiStore } from '@/stores/vision-ai';

const emit = defineEmits<{
  onWidgetClick: [interaction: string];
}>();

const props = withDefaults(
  defineProps<{
    widgetData: LibraryMediaWidgetData;
    layout?: 'column' | 'row';
    compact?: boolean;
  }>(),
  { layout: 'column', compact: false },
);

const visionAiStore = useVisionAiStore();

const mediaItems = computed(() => props.widgetData?.media_items ?? []);

function onCardClick() {
  emit('onWidgetClick', VISION_AI_SUMMARY_INTERACTIONS.POST_CLICK);
  visionAiStore.closeChatWindow();
}
</script>

<template>
  <div
    :class="[
      '!flex !gap-[--space-16]',
      props.layout === 'column' ? '!flex-col' : '!flex-row !overflow-x-auto !pb-[--space-8]',
      props.compact && '!max-w-[300px] !flex-[1_1_200px]',
    ]"
    data-testid="library-media-widget"
  >
    <div
      v-for="(media, index) in mediaItems"
      :key="(media.source_id as string) ?? `library-media-${index}`"
      :class="layout === 'column' ? 'max-w-[300px]' : 'flex w-[200px] shrink-0'"
    >
      <MediaCard :media="media" show-user-details @click="onCardClick" />
    </div>
  </div>
</template>
